<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body no-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <div style="text-align: center; padding: 40px;">
      <i class="fa fa-spinner fa-spin gt-refresh" style="font-size: 24px; margin-bottom: 15px;"></i>
    </div>
  </div>
}
  
  @if (!showFormLoader) {
<div>

    <div class="text-center boldText"><h3>{{modalTitle}}</h3></div>

    <!-- Summary Table -->
    <div class="form-group col-md-offset-1 col-md-10">
      <table class="table table-bordered table-condensed table-hover boldText custom-table">
        <thead>
          <tr>
            <th colspan="5">{{labelSummary}}:</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{labelTotal959c3EPPoolFuncCurr}}</td>
            <td>{{total959c3EPPoolFuncCurr | number}}</td>
            <td>&nbsp;&nbsp;</td>
            <td>{{labelTotalPtiFuncCurr}}</td>
            <td nowrap="nowrap">{{totalPtiFuncCurr | number}}</td>
          </tr>
          <tr>
            <td>{{labelTotal959c3EPPoolUSD}}</td>
            <td>{{total959c3EPPoolUSD | number}}</td>
            <td>&nbsp;&nbsp;</td>
            <td>{{labelTotalPtiUSD}}</td>
            <td nowrap="nowrap">{{totalPtiUSD | number}}</td>
          </tr>
          <tr>
            <td>{{labelTotalTaxPool}}</td>
            <td nowrap="nowrap">{{totalTaxPool | number}}</td>
            <td>&nbsp;&nbsp;</td>
            <td>{{labelTotalUSDBasisInPti}}</td>
            <td nowrap="nowrap">{{totalUSDBasisInPti | number}}</td>
          </tr>
          <tr>
            <td>{{labelEffectiveRateOn959c3TotalEp}}</td>
            <td nowrap="nowrap">{{effectiveRateOn959c3TotalEp | number:'1.2-2'}}%</td>
            <td>&nbsp;&nbsp;</td>
            <td>{{labelEstimatedPtiExchangeGainLoss}}</td>
            <td nowrap="nowrap">{{estimatedPtiExchangeGainLoss | number}}</td>
          </tr>
          <tr>
            <td>{{labelRecaptureAccts}}</td>
            <td>{{recaptureAccounts}}</td>
            <td>&nbsp;&nbsp;</td>
            <td>{{labelQualDefs}}</td>
            <td>{{qualifiedDeficits}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Adjustment Description Section -->
    <div class="form-group text-center col-md-12">
      <div class="text-right col-md-3">{{labelAdjDesc}}:</div>
      <div class="col-md-6">
        <input type="text" 
               name="adjust_desc" 
               [(ngModel)]="adjDesc" 
               maxlength="255" 
               class="form-control" 
               style="width: 100%;" />
      </div>
      <div class="text-left col-md-3">
        <input type="checkbox" 
               name="isG2G" 
               [(ngModel)]="isG2GChecked" />{{labelThisProspectiveAdj}}
        <a href="javascript:void(0)" id="showToolTip">
          <i class="fa fa-info-circle" [title]="labelprospectiveAdjTitle"></i>
        </a>
      </div>
    </div>

    <!-- Data Tables Section -->

    @if (allTotals && getObjectKeys(allTotals).length > 0) {
<div class="form-group col-md-12">
      
      <!-- Foreign C3 Section -->
      @if (allTotals.hasOwnProperty('FOREIGN_C3') && editableTotals.hasOwnProperty('FOREIGN_C3')) {
<div class="boldText">
        <div>
          <span>{{foreignC3Header}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th>{{labelYear}}</th>
            <th colspan="3">{{labelAdjType}}</th>
            @for (foreignC3AmtRow of allTotals.FOREIGN_C3; track $index; let key = $index) {
<th 
                [attr.colspan]="foreignC3AmtRow.BASKET_DESC === 'Total' ? 1 : ''">
              {{foreignC3AmtRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (foreignC3AmtRow of allTotals.FOREIGN_C3; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="foreignC3AmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                {{foreignC3AmtRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (foreignC3EditableRows of getObjectKeys(editableTotals.FOREIGN_C3); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.FOREIGN_C3[foreignC3EditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.FOREIGN_C3[foreignC3EditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="3">
                <select [(ngModel)]="editableTotals.FOREIGN_C3[foreignC3EditableRows].ADJ_TYPE" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjType of adjTypeSL; track $index) {
<option
                          [ngValue]="adjType.CODE_NAME"
                          [selected]="editableTotals.FOREIGN_C3[foreignC3EditableRows].ADJ_TYPE == adjType.CODE_NAME">
                    {{adjType.CODE_NAME}}
                  </option>
}
                </select>
              </td>
              @for (foreignC3EditableAmtRow of editableTotals.FOREIGN_C3[foreignC3EditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="foreignC3EditableAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                @if (foreignC3EditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{foreignC3EditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (foreignC3EditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="foreignC3EditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('FOREIGN_C3', foreignC3EditableAmtRow.EDITED_TOTAL_AMT, +foreignC3EditableRows, foreignC3EditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.FOREIGN_C3 && editableTotals.FOREIGN_C3.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (foreignC3TotalAmtRow of editableTotals.FOREIGN_C3['0'].AMOUNT_DATA; track $index; let key = $index) {
<td
                  class="text-right" 
                  [attr.colspan]="foreignC3TotalAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                {{foreignC3TotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- Foreign C3 Taxes Section -->
      @if (allTotals.hasOwnProperty('FOREIGN_C3_TAXES') && editableTotals.hasOwnProperty('FOREIGN_C3_TAXES')) {
<div class="boldText">
        <div>
          <span>{{foreignC3TaxesHeader}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th>{{labelYear}}</th>
            <th colspan="3">{{labelAdjType}}</th>
            @for (foreignC3TaxesAmtRow of allTotals.FOREIGN_C3_TAXES; track $index; let key = $index) {
<th 
                [attr.colspan]="foreignC3TaxesAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
              {{foreignC3TaxesAmtRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (foreignC3TaxesAmtRow of allTotals.FOREIGN_C3_TAXES; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="foreignC3TaxesAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                {{foreignC3TaxesAmtRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (foreignC3TaxesEditableRows of getObjectKeys(editableTotals.FOREIGN_C3_TAXES); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.FOREIGN_C3_TAXES[foreignC3TaxesEditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.FOREIGN_C3_TAXES[foreignC3TaxesEditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="3">
                <select [(ngModel)]="editableTotals.FOREIGN_C3_TAXES[foreignC3TaxesEditableRows].ADJ_TYPE" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjType of adjTypeTaxesSL; track $index) {
<option
                          [ngValue]="adjType.CODE_NAME"
                          [selected]="editableTotals.FOREIGN_C3_TAXES[foreignC3TaxesEditableRows].ADJ_TYPE == adjType.CODE_NAME">
                    {{adjType.CODE_NAME}}
                  </option>
}
                </select>
              </td>
              @for (foreignC3TaxesEditableAmtRow of editableTotals.FOREIGN_C3_TAXES[foreignC3TaxesEditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="foreignC3TaxesEditableAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                @if (foreignC3TaxesEditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{foreignC3TaxesEditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (foreignC3TaxesEditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="foreignC3TaxesEditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('FOREIGN_C3_TAXES', foreignC3TaxesEditableAmtRow.EDITED_TOTAL_AMT, +foreignC3TaxesEditableRows, foreignC3TaxesEditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.FOREIGN_C3_TAXES && editableTotals.FOREIGN_C3_TAXES.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (foreignC3TaxesTotalAmtRow of editableTotals.FOREIGN_C3_TAXES['0'].AMOUNT_DATA; track $index; let key = $index) {
<td
                  class="text-right" 
                  [attr.colspan]="foreignC3TaxesTotalAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                {{foreignC3TaxesTotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- Hovering Deficit Foreign C3 Section -->
      @if (allTotals.hasOwnProperty('HDEFICIT_FOREIGN_C3') && editableTotals.hasOwnProperty('HDEFICIT_FOREIGN_C3')) {
<div class="boldText">
        <div>
          <span>{{hdInForeignC3Header}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th>{{labelYear}}</th>
            <th colspan="3">{{labelAdjType}}</th>
            @for (hdForeignC3AmtRow of allTotals.HDEFICIT_FOREIGN_C3; track $index; let key = $index) {
<th 
                [attr.colspan]="hdForeignC3AmtRow.BASKET_DESC === 'Total' ? 1 : ''">
              {{hdForeignC3AmtRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (hdForeignC3AmtRow of allTotals.HDEFICIT_FOREIGN_C3; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="hdForeignC3AmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                {{hdForeignC3AmtRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (hdForeignC3EditableRows of getObjectKeys(editableTotals.HDEFICIT_FOREIGN_C3); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.HDEFICIT_FOREIGN_C3[hdForeignC3EditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.HDEFICIT_FOREIGN_C3[hdForeignC3EditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="3">
                <select [(ngModel)]="editableTotals.HDEFICIT_FOREIGN_C3[hdForeignC3EditableRows].ADJ_TYPE" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjType of adjTypeSL; track $index) {
<option
                          [ngValue]="adjType.CODE_NAME"
                          [selected]="editableTotals.HDEFICIT_FOREIGN_C3[hdForeignC3EditableRows].ADJ_TYPE == adjType.CODE_NAME">
                    {{adjType.CODE_NAME}}
                  </option>
}
                </select>
              </td>
              @for (hdForeignC3EditableAmtRow of editableTotals.HDEFICIT_FOREIGN_C3[hdForeignC3EditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="hdForeignC3EditableAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                @if (hdForeignC3EditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{hdForeignC3EditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (hdForeignC3EditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="hdForeignC3EditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('HDEFICIT_FOREIGN_C3', hdForeignC3EditableAmtRow.EDITED_TOTAL_AMT, +hdForeignC3EditableRows, hdForeignC3EditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.HDEFICIT_FOREIGN_C3 && editableTotals.HDEFICIT_FOREIGN_C3.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (hdForeignC3TotalAmtRow of editableTotals.HDEFICIT_FOREIGN_C3['0'].AMOUNT_DATA; track $index; let key = $index) {
<td
                  class="text-right" 
                  [attr.colspan]="hdForeignC3TotalAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                {{hdForeignC3TotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- Hovering Deficit Foreign C3 Taxes Section -->
      @if (allTotals.hasOwnProperty('HDEFICIT_FOREIGN_C3_TAXES') && editableTotals.hasOwnProperty('HDEFICIT_FOREIGN_C3_TAXES')) {
<div class="boldText">
        <div>
          <span>{{hdInForeignC3TaxesHeader}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th>{{labelYear}}</th>
            <th colspan="3">{{labelAdjType}}</th>
            @for (hdForeignC3TaxesAmtRow of allTotals.HDEFICIT_FOREIGN_C3_TAXES; track $index; let key = $index) {
<th 
                [attr.colspan]="hdForeignC3TaxesAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
              {{hdForeignC3TaxesAmtRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (hdForeignC3TaxesAmtRow of allTotals.HDEFICIT_FOREIGN_C3_TAXES; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="hdForeignC3TaxesAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                {{hdForeignC3TaxesAmtRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (hdForeignC3TaxesEditableRows of getObjectKeys(editableTotals.HDEFICIT_FOREIGN_C3_TAXES); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.HDEFICIT_FOREIGN_C3_TAXES[hdForeignC3TaxesEditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.HDEFICIT_FOREIGN_C3_TAXES[hdForeignC3TaxesEditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="3">
                <select [(ngModel)]="editableTotals.HDEFICIT_FOREIGN_C3_TAXES[hdForeignC3TaxesEditableRows].ADJ_TYPE" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjType of adjTypeTaxesSL; track $index) {
<option
                          [ngValue]="adjType.CODE_NAME"
                          [selected]="editableTotals.HDEFICIT_FOREIGN_C3_TAXES[hdForeignC3TaxesEditableRows].ADJ_TYPE == adjType.CODE_NAME">
                    {{adjType.CODE_NAME}}
                  </option>
}
                </select>
              </td>
              @for (hdForeignC3TaxesEditableAmtRow of editableTotals.HDEFICIT_FOREIGN_C3_TAXES[hdForeignC3TaxesEditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="hdForeignC3TaxesEditableAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                @if (hdForeignC3TaxesEditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{hdForeignC3TaxesEditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (hdForeignC3TaxesEditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="hdForeignC3TaxesEditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('HDEFICIT_FOREIGN_C3_TAXES', hdForeignC3TaxesEditableAmtRow.EDITED_TOTAL_AMT, +hdForeignC3TaxesEditableRows, hdForeignC3TaxesEditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.HDEFICIT_FOREIGN_C3_TAXES && editableTotals.HDEFICIT_FOREIGN_C3_TAXES.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (hdForeignC3TaxesTotalAmtRow of editableTotals.HDEFICIT_FOREIGN_C3_TAXES['0'].AMOUNT_DATA; track $index; let key = $index) {
<td
                  class="text-right" 
                  [attr.colspan]="hdForeignC3TaxesTotalAmtRow.BASKET_DESC === 'Total' ? 1 : ''">
                {{hdForeignC3TaxesTotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- PTI FC Section -->
      @if (allTotals.hasOwnProperty('PTI_FC') && editableTotals.hasOwnProperty('PTI_FC')) {
<div class="boldText">
        <div>
          <span>{{ptiFCHeader}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th>{{labelPtiGenYr}}</th>
            <th>{{labelAdjType}}</th>
            <th>{{labelOwnSub}}</th>
            <th>{{labelPtiType}}</th>
            @for (ptiFCRow of allTotals.PTI_FC; track $index; let key = $index) {
<th 
                [attr.colspan]="ptiFCRow.BASKET_DESC === 'Total' ? 2 : ''">
              {{ptiFCRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (ptiFCRow of allTotals.PTI_FC; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="ptiFCRow.BASKET_DESC === 'Total' ? 2 : ''">
                {{ptiFCRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (ptiFCEditableRows of getObjectKeys(editableTotals.PTI_FC); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.PTI_FC[ptiFCEditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.PTI_FC[ptiFCEditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="1">{{editableTotals.PTI_FC[ptiFCEditableRows].ADJ_TYPE}}</td>
              <td colspan="1">
                <select [(ngModel)]="editableTotals.PTI_FC[ptiFCEditableRows].OWN_SUB" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (ownSub of ownSubSL; track $index) {
<option
                          [ngValue]="ownSub.value"
                          [selected]="editableTotals.PTI_FC[ptiFCEditableRows].OWN_SUB == ownSub.value">
                    {{ownSub.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="1">
                <select [(ngModel)]="editableTotals.PTI_FC[ptiFCEditableRows].PTI_TYPE" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (ptiType of ptiTypeSL; track $index) {
<option
                          [ngValue]="ptiType.value"
                          [selected]="editableTotals.PTI_FC[ptiFCEditableRows].PTI_TYPE == ptiType.value">
                    {{ptiType.label}}
                  </option>
}
                </select>
              </td>
              @for (ptiFCEditableAmtRow of editableTotals.PTI_FC[ptiFCEditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="ptiFCEditableAmtRow.BASKET_DESC === 'Total' ? 2 : ''">
                @if (ptiFCEditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{ptiFCEditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (ptiFCEditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="ptiFCEditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('PTI_FC', ptiFCEditableAmtRow.EDITED_TOTAL_AMT, +ptiFCEditableRows, ptiFCEditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.PTI_FC && editableTotals.PTI_FC.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (ptiFCTotalAmtRow of editableTotals.PTI_FC['0'].AMOUNT_DATA; track $index; let key = $index) {
<td
                  class="text-right" 
                  [attr.colspan]="ptiFCTotalAmtRow.BASKET_DESC === 'Total' ? 2 : ''">
                {{ptiFCTotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- PTI BC Section -->
      @if (allTotals.hasOwnProperty('PTI_BC') && editableTotals.hasOwnProperty('PTI_BC')) {
<div class="boldText">
        <div>
          <span>{{ptiUSDHeader}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th>{{labelPtiGenYr}}</th>
            <th colspan="3">{{labelAdjType}}</th>
            @for (ptiBCRow of allTotals.PTI_BC; track $index; let key = $index) {
<th 
                [attr.colspan]="ptiBCRow.BASKET_DESC === 'Total' ? 2 : ''">
              {{ptiBCRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (ptiBCRow of allTotals.PTI_BC; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="ptiBCRow.BASKET_DESC === 'Total' ? 2 : ''">
                {{ptiBCRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (ptiBCEditableRows of getObjectKeys(editableTotals.PTI_BC); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.PTI_BC[ptiBCEditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.PTI_BC[ptiBCEditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="3">{{editableTotals.PTI_BC[ptiBCEditableRows].ADJ_TYPE}}</td>
              @for (ptiBCEditableAmtRow of editableTotals.PTI_BC[ptiBCEditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="ptiBCEditableAmtRow.BASKET_DESC === 'Total' ? 2 : ''">
                @if (ptiBCEditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{ptiBCEditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (ptiBCEditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="ptiBCEditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('PTI_BC', ptiBCEditableAmtRow.EDITED_TOTAL_AMT, +ptiBCEditableRows, ptiBCEditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.PTI_BC && editableTotals.PTI_BC.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (ptiBCTotalAmtRow of editableTotals.PTI_BC['0'].AMOUNT_DATA; track $index; let key = $index) {
<td
                  class="text-right" 
                  [attr.colspan]="ptiBCTotalAmtRow.BASKET_DESC === 'Total' ? 2 : ''">
                {{ptiBCTotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- Recapture Account Section -->
      @if (allTotals.hasOwnProperty('RECAP_ACCT') && editableTotals.hasOwnProperty('RECAP_ACCT')) {
<div class="boldText">
        <div>
          <span>{{recapAcctHeader}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th>{{labelAdjRelToYr}}</th>
            <th colspan="3">{{labelAdjType}}</th>
            @for (recapAcctRow of allTotals.RECAP_ACCT; track $index; let key = $index) {
<th 
                [attr.colspan]="recapAcctRow.BASKET_DESC === 'Total' ? 2 : ''">
              {{recapAcctRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (recapAcctRow of allTotals.RECAP_ACCT; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="recapAcctRow.BASKET_DESC === 'Total' ? 2 : ''">
                {{recapAcctRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (recapAcctEditableRows of getObjectKeys(editableTotals.RECAP_ACCT); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.RECAP_ACCT[recapAcctEditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.RECAP_ACCT[recapAcctEditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="3">{{editableTotals.RECAP_ACCT[recapAcctEditableRows].ADJ_TYPE}}</td>
              @for (recapAcctEditableAmtRow of editableTotals.RECAP_ACCT[recapAcctEditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="recapAcctEditableAmtRow.BASKET_DESC === 'Total' ? 2 : ''">
                @if (recapAcctEditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{recapAcctEditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (recapAcctEditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="recapAcctEditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('RECAP_ACCT', recapAcctEditableAmtRow.EDITED_TOTAL_AMT, +recapAcctEditableRows, recapAcctEditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.RECAP_ACCT && editableTotals.RECAP_ACCT.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (recapAcctTotalAmtRow of editableTotals.RECAP_ACCT['0'].AMOUNT_DATA; track $index; let key = $index) {
<td
                  class="text-right" 
                  [attr.colspan]="recapAcctTotalAmtRow.BASKET_DESC === 'Total' ? 2 : ''">
                {{recapAcctTotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- Qualified Deficits Section -->
      @if (allTotals.hasOwnProperty('QUAL_DEF') && editableTotals.hasOwnProperty('QUAL_DEF')) {
<div class="boldText">
        <div>
          <span>{{qualDefHeader}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th>{{labelAdjRelToYr}}</th>
            <th colspan="3">{{labelAdjType}}</th>
            @for (qualDefRow of allTotals.QUAL_DEF; track $index; let key = $index) {
<th 
                [attr.colspan]="qualDefRow.BASKET_DESC === 'Total' ? 2 : ''">
              {{qualDefRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (qualDefRow of allTotals.QUAL_DEF; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="qualDefRow.BASKET_DESC === 'Total' ? 2 : ''">
                {{qualDefRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (qualDefEditableRows of getObjectKeys(editableTotals.QUAL_DEF); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.QUAL_DEF[qualDefEditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.QUAL_DEF[qualDefEditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="3">{{editableTotals.QUAL_DEF[qualDefEditableRows].ADJ_TYPE}}</td>
              @for (qualDefEditableAmtRow of editableTotals.QUAL_DEF[qualDefEditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="qualDefEditableAmtRow.BASKET_DESC === 'Total' ? 2 : ''">
                @if (qualDefEditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{qualDefEditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (qualDefEditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="qualDefEditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('QUAL_DEF', qualDefEditableAmtRow.EDITED_TOTAL_AMT, +qualDefEditableRows, qualDefEditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.QUAL_DEF && editableTotals.QUAL_DEF.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (qualDefTotalAmtRow of editableTotals.QUAL_DEF['0'].AMOUNT_DATA; track $index; let key = $index) {
<td
                  class="text-right" 
                  [attr.colspan]="qualDefTotalAmtRow.BASKET_DESC === 'Total' ? 2 : ''">
                {{qualDefTotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- Others Section -->
      @if (allTotals.hasOwnProperty('OTHERS') && editableTotals.hasOwnProperty('OTHERS')) {
<div>
        <div>
          <span>{{otherAttrsHeader}}</span>
        </div>
        <table class="table table-bordered table-hover custom-table">
          <thead>
            <th colspan="1">{{labelAdjRelToYr}}</th>
            <th colspan="3">{{labelAdjType}}</th>
            @for (othersRow of allTotals.OTHERS; track $index; let key = $index) {
<th 
                [attr.colspan]="othersRow.BASKET_DESC === 'Total' ? 4 : ''">
              {{othersRow.BASKET_DESC}}
            </th>
}
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">{{gtapsBalanceHeader}}</td>
              @for (othersRow of allTotals.OTHERS; track $index; let key = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="othersRow.BASKET_DESC === 'Total' ? 4 : ''">
                {{othersRow.TOTAL_AMT | number}}
              </td>
}
            </tr>
            @for (othersEditableRows of getObjectKeys(editableTotals.OTHERS); track $index; let key = $index) {
<tr 
                [hidden]="key === 0">
              <td>
                <select [(ngModel)]="editableTotals.OTHERS[othersEditableRows].ADJ_YEAR" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjYear of taxYearSL; track $index) {
<option
                          [ngValue]="adjYear.value"
                          [selected]="editableTotals.OTHERS[othersEditableRows].ADJ_YEAR == adjYear.value">
                    {{adjYear.label}}
                  </option>
}
                </select>
              </td>
              <td colspan="3">
                <select [(ngModel)]="editableTotals.OTHERS[othersEditableRows].ADJ_TYPE" 
                        class="form-control ddWidth">
                  <option [ngValue]="''"></option>
                  @for (adjType of adjTypeSL; track $index) {
<option
                          [ngValue]="adjType.CODE_NAME"
                          [selected]="editableTotals.OTHERS[othersEditableRows].ADJ_TYPE == adjType.CODE_NAME">
                    {{adjType.CODE_NAME}}
                  </option>
}
                </select>
              </td>
              @for (othersEditableAmtRow of editableTotals.OTHERS[othersEditableRows].AMOUNT_DATA; track $index; let childKey = $index) {
<td 
                  class="text-right" 
                  [attr.colspan]="othersEditableAmtRow.BASKET_DESC === 'Total' ? 4 : ''">
                @if (othersEditableAmtRow.BASKET_DESC === 'Total') {
<span>
                  {{othersEditableAmtRow.EDITED_TOTAL_AMT | number}}
                </span>
}
                @if (othersEditableAmtRow.BASKET_DESC !== 'Total') {
<input 
                       type="text" 
                       [(ngModel)]="othersEditableAmtRow.EDITED_TOTAL_AMT"
                       (blur)="amountFieldOnChange('OTHERS', othersEditableAmtRow.EDITED_TOTAL_AMT, +othersEditableRows, othersEditableAmtRow.BASKET_DESC)"
                       placeholder="0" 
                       class="form-control text-right" />
}
              </td>
}
            </tr>
}
            @if (editableTotals.OTHERS && editableTotals.OTHERS.hasOwnProperty('0')) {
<tr>
              <td colspan="4" class="text-center">{{labelTotals}}</td>
              @for (othersTotalAmtRow of editableTotals.OTHERS['0'].AMOUNT_DATA; track $index; let key = $index) {
<td 
                  class="text-right"
                  [attr.colspan]="othersTotalAmtRow.BASKET_DESC === 'Total' ? 4 : ''">
                {{othersTotalAmtRow.EDITED_TOTAL_AMT | number}}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

    </div>
}
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}{{labelSaveAndUpdate}}
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">{{labelReset}}</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">{{labelCancel}}</button>
</div>